module.exports = __webpack_public_path__ + "media/hallBgm.c4b43e89.mp3";